import { render } from "./NormalUserRequestView.vue?vue&type=template&id=76fe8446"
import script from "./NormalUserRequestView.vue?vue&type=script&lang=js"
export * from "./NormalUserRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__